import React from "react";
const GlobalDataContext = React.createContext();
export default GlobalDataContext;
